import { render, staticRenderFns } from "./app.public.vue?vue&type=template&id=55362b10&"
import script from "./app.public.vue?vue&type=script&lang=js&"
export * from "./app.public.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports